export class GdsgInventoryReportFrequencyOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "frequency",
            "baseName": "frequency",
            "type": "GdsgInventoryReportFrequency",
            "format": ""
        },
        {
            "name": "startDate",
            "baseName": "startDate",
            "type": "string",
            "format": "date"
        },
        {
            "name": "endDate",
            "baseName": "endDate",
            "type": "string",
            "format": "date"
        }
    ];
    static getAttributeTypeMap() {
        return GdsgInventoryReportFrequencyOptions.attributeTypeMap;
    }
    constructor() {
    }
}
